import { render } from "./MarzipanoInput.vue?vue&type=template&id=40554993"
import script from "./MarzipanoInput.vue?vue&type=script&lang=js"
export * from "./MarzipanoInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/jean/lienzo/quinta_amelia_dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__